import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment} from "../../environments/environment";

/*const httpOptions = {
  headers: new HttpHeaders({'x-api-key':'apikey','Authorization':localStorage.getItem("access_token")})
};*/


@Injectable({
  providedIn: 'root'
})
export class ApiService {
  
  //private serverUrl='http://localhost/webapp/server/';
  private serverUrl=environment.serverUrl;
  constructor(private http:HttpClient) { }
  
  post(formValue,url):Observable<any>
  {
    return this.http.post<any>(this.serverUrl+url,formValue,{headers:new HttpHeaders({'x-api-key':'apikey','Authorization':localStorage.getItem("access_token")})}).pipe(
      catchError(this.handleErros)
    );
  }

  get(url):Observable<any>
  {
    return this.http.get<any>(this.serverUrl+url,{headers:new HttpHeaders({'x-api-key':'apikey','Authorization':localStorage.getItem("access_token")})}).pipe(
      catchError(this.handleErros)
    );
  }

  handleErros(error:HttpErrorResponse){
    return throwError(error);
  }
}
